import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { Modulos } from 'src/app/core/modulos';
import { AcessoModuloResolver } from 'src/app/guards/acesso-modulo.resolve';
import { AuthGuard } from 'src/app/guards/auth.guard';
import { RelatoriosHistoricoBeneficiarioComponent } from './relatorios-historico-beneficiario.component';


const routes: Routes = [
  { path: 'relhistbeneficiarios', component: RelatoriosHistoricoBeneficiarioComponent,canActivate: [AuthGuard],resolve: {perfilAcesso:AcessoModuloResolver}, data:{modulo:Modulos.RELATORIO_HISTORICO_BENEFICIARIO} },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class RelatoriosHistoricoBeneficiarioRoutingModule { }
